namespace GeniuzPOS.Administration {
    export interface UnlockUserForm {
        Username: Serenity.StringEditor;
        UnlockUser: Serenity.EnumEditor;
    }

    export class UnlockUserForm extends Serenity.PrefixedContext {
        static formKey = 'Members.UnlockUserForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UnlockUserForm.init)  {
                UnlockUserForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;

                Q.initFormType(UnlockUserForm, [
                    'Username', w0,
                    'UnlockUser', w1
                ]);
            }
        }
    }
}
